import {
  SurchargeDisputeDataSchema,
  SurchargeDisputeUpdateSchema,
} from "@redotech/redo-model/balance/surcharge-dispute";
import * as z from "zod/v4";

export const updateSurchargeDispute = {
  name: "updateSurchargeDispute" as const,
  input: SurchargeDisputeUpdateSchema,
  output: z.object({ dispute: SurchargeDisputeDataSchema }),
};
